import React from "react";
import ApplicationOverview from "../../../features/application/ApplicationOverview";

interface OverviewProps {
  title: string;
  description: string;
  subtitle: string;
  userProfile: {
    name?: string;
    imageUrl?: string;
    profilePicture?: string;
    firstName?: string;
    lastName?: string;
  };
  metrics: {
    adminImage?: string | null;
    label: string;
    name?: string;
    role?: string;
    goal?: string;
    total?: number;
    approved?: number;
    rejected?: number;
    currentStat?: string;
    jobOpportuinity?: string;
  }[];
  table: {
    columns: {
      Header?: string;
      accessor: string;
      name?: string;
    }[];
    data: {
      [key: string]: string | number;
    }[];
  };
}

const Overview: React.FC<OverviewProps> = ({
  metrics,
  table,
}) => {

  return (
    <div className="flex h-screen w-full">
        <div className="w-full items-center justify-center">
          <ApplicationOverview metrics={metrics[0]} />

          <div className="flex flex-col gap-x-6 md:flex-row">
            {/* Chart */}
            <div className="bg-white shadow rounded-[8px] py-[30px] px-4 mb-8 w-full  h-[420px] md:px-[60px] md:w-[50%] md:h-[420px]">
              <h2 className="text-[24px] font-ubuntu font-[600]">Placement</h2>
              <hr className="border-[1px] border-gray-300 my-4" />
              <div className="w-[100%] md:w-[100%] h-[250px] md:h-[250px]">
                {/* <Chart /> */}
                <p>No data to display</p>
              </div>
            </div>

            <div className="grid grid-rows-1 gap-5 w-[100%] h-[420px] mb-8 md:mb-[2px] md:w-[50%] md:grid-rows-2">
                <div
                  className={`bg-white shadow rounded-[8px] md:px-6 py-[30px] cursor-pointer flex flex-col items-center`}
                  // onClick={() => setSelectedMetric(index)}
                >
                  <div className="w-full px-4 md:px-[30px]">
                    <div className="text-left">
                      <h2 className="text-[24px] font-ubuntu font-[600] mb-2">
                        Mentor's Profile
                      </h2>
                      <hr className="border-[1px] border-gray-300 my-4" />
                    </div>
                    <p>No data to display</p>
                  </div>
                </div>
                <div
                  className={`bg-white shadow rounded-[8px] md:px-6 py-[30px] cursor-pointer flex flex-col items-center`}
                  // onClick={() => setSelectedMetric(index)}
                >
                  <div className="w-full px-4 md:px-[30px]">
                    <div className="text-left">
                      <h2 className="text-[24px] font-ubuntu font-[600] mb-2">
                        Career goals
                      </h2>
                      <hr className="border-[1px] border-gray-300 my-4" />
                    </div>
                    <p>No data to display</p>
                  </div>
                </div>
            </div>
          </div>

          <div className="bg-white shadow rounded-[8px] py-[32px] px-4 mb-8 md:mb-0 md:px-[60px]">
            <div className="w-full">
              {" "}
              <div className="w-full flex flex-row justify-between items-center mb-[8px]">
                {" "}
                <h2 className="text-[24px] font-ubuntu font-[600]">
                  Repayment
                </h2>{" "}
                <button
                  onClick={() => alert("Update Repayment")}
                  className="text-[14px] text-[#005C99] font-ubuntu font-[700] cursor-pointer"
                >
                  {" "}
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.3125 3.125H4.6875C3.82456 3.125 3.125 3.82456 3.125 4.6875V20.3125C3.125 21.1754 3.82456 21.875 4.6875 21.875H20.3125C21.1754 21.875 21.875 21.1754 21.875 20.3125V4.6875C21.875 3.82456 21.1754 3.125 20.3125 3.125Z"
                      stroke="#0073C0"
                      strokeWidth="2.08333"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M12.4999 8.33334V16.6667M8.33325 12.5H16.6666"
                      stroke="#0073C0"
                      strokeWidth="2.08333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>{" "}
              </div>{" "}
              <hr className="border-[1px] border-gray-300 my-4" />{" "}
            </div>
            <table className="w-full">
              <thead>
                <tr>
                  {table.columns.map((column, index) => (
                    <th key={index} className="text-left font-ubuntu">
                      {column.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="p-8">
                <p>No data to display</p>
                {/* {table.data.map((row, index) => (
                  <tr
                    key={index}
                    className="bg-[#fafafa] shadow rounded-[20px] py-[60px] px-[60px]"
                  >
                    <td className="flex flex-col text-left w-[100%]">
                      {index + 1}. {row[table.columns[0].accessor]}
                    </td>
                    <td className="text-center w-[70%]">
                      {row[table.columns[1].accessor]}
                    </td>
                    <td className="flex items-center justify-center w-full">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="-0.5 -0.5 16 16"
                        fill="currentColor"
                        id="Caret-Right--Streamline-Phosphor"
                        height="16"
                        width="16"
                      >
                        <path
                          d="M11.313375 7.972716796875 4.63189453125 14.654197265625c-0.363890625 0.363896484375 -0.9852597656250001 0.19740234375000001 -1.118455078125 -0.299689453125 -0.061810546875 -0.230701171875 0.004142578125 -0.47685937500000003 0.17302734374999998 -0.645744140625L9.896068359375 7.5 3.686466796875 1.2912363281249999c-0.363896484375 -0.363896484375 -0.19740234375000001 -0.9852597656250001 0.299689453125 -1.118455078125 0.230701171875 -0.06181640625 0.47685351562499995 0.00413671875 0.64573828125 0.173021484375l6.68148046875 6.68148046875c0.26128125 0.26098828125 0.26128125 0.6844453125000001 0 0.94543359375Z"
                          strokeWidth="1"
                        ></path>
                      </svg>
                    </td>
                  </tr>
                ))} */}
              </tbody>
            </table>
          </div>
        </div>
    </div>
  );
};

export default Overview;
